import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type FaqItem = {
  question: string;
  answer: string;
};

const FAQ_ITEMS: readonly FaqItem[] = [
  {
    question: 'What services does Ancient Engineering provide?',
    answer:
      'We provide comprehensive multi-discipline engineering solutions including Industrial Automation & Control Engineering, Green Energy Solutions (Solar PV), Fabrication, Refractory & Mechanical services, and Technical Services, ICT & Security.',
  },
  {
    question: 'What industries do you serve?',
    answer:
      'We serve clients across Mining, Construction, and Manufacturing sectors, providing turnkey solutions tailored to each industry\'s unique requirements.',
  },
  {
    question: 'Are you a Zimbabwean-owned company?',
    answer:
      'Yes, Ancient Engineering is a Zimbabwean-owned firm dedicated to serving the local market with international standards of engineering excellence.',
  },
  {
    question: 'How can I get started with a project?',
    answer:
      'Getting started is easy. Simply contact us through our contact form, email, or phone. Our team will schedule a consultation to understand your requirements, assess your needs, and provide a detailed proposal with timelines and pricing for your project.',
  },
  {
    question: 'Do you provide maintenance and support services after project completion?',
    answer:
      'Yes, we offer comprehensive maintenance and support services to ensure your systems continue to operate at peak performance. Our team provides ongoing technical support, preventive maintenance, troubleshooting, and system upgrades to help you maximize the value of your investment.',
  },
];

export default function HomeFaqNewsletter(): React.ReactElement {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          {/* Left Side - Text Content */}
          <div className="flex flex-col justify-center text-left">
            <h2 className="text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl text-left">
              FAQ
            </h2>
            <p className="mt-4 text-lg font-medium text-slate-700 text-left">
              Questions commonly asked, stuff
            </p>
            <p className="mt-6 text-base leading-relaxed text-slate-600 text-left">
              We understand that you may have questions about our services,
              expertise, and how we can help with your engineering needs. Below
              are some of the most frequently asked questions we receive from
              our clients.
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-600 text-left">
              If you don&apos;t find the answer you&apos;re looking for, please
              don&apos;t hesitate to reach out to us directly. Our team is always
              ready to provide personalized assistance and answer any specific
              questions about your project requirements.
            </p>
          </div>

          {/* Right Side - FAQ Accordion */}
          <div className="flex flex-col">
            <div className="space-y-4">
              {FAQ_ITEMS.map((item, index) => (
                <div
                  key={index}
                  className="overflow-hidden rounded-lg bg-white ring-1 ring-slate-200"
                >
                  <button
                    type="button"
                    onClick={() => handleToggle(index)}
                    className="flex w-full items-center justify-between px-6 py-4 text-left transition-colors hover:bg-slate-50"
                    aria-expanded={openIndex === index}
                  >
                    <span className="pr-4 font-semibold text-slate-900">
                      {item.question}
                    </span>
                    <ExpandMoreIcon
                      className={`flex-shrink-0 text-slate-600 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index
                        ? 'max-h-96 opacity-100'
                        : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-6 pb-4 text-sm leading-relaxed text-slate-600 sm:text-base">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

